<template>
  <div v-if="hasActions">
    <v-menu bottom left z-index="500" :disabled="disabled || loading">
      <v-btn slot="activator" dark flat icon :loading="loading">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">settings</v-icon>
          </template>
          <span>{{ $t('message.common.settings') }}</span>
        </v-tooltip>
      </v-btn>
      <v-list dense>
        <v-list-tile
          v-for="action in actions"
          :key="action.name"
          ripple
          @click="setCurrentAction(action)"
        >
          <v-list-tile-action>
            <v-icon>{{ action.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              {{ $t(`message.entity.actions.${action.name}`) | capitalize }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-menu>
    <component
      :is="currentAction.component"
      v-if="currentAction"
      :editor-store-path="editorStorePath"
      :entity="entity"
      @close="reset"
      @loading="setLoading"
    />
  </div>
</template>

<script>
import tools from '@/modules/taxonomy/config/tools';
import SimpleDialog from '@/components/dialogs/SimpleDialog.vue';
import { getEntityActionsByNames } from '@/modules/entity/actions';
import { toArray } from '@/utils';
import isObject from 'lodash/isObject';

export default {
  name: 'nx-entity-editor-actions',
  components: {
    [SimpleDialog.name]: SimpleDialog,
  },
  props: {
    entity: {
      type: String,
      required: true,
    },
    config: {
      type: Object,
      required: true,
    },
    draft: {
      type: Object,
    },
    editorStorePath: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      loading: false,
      currentAction: null,
    };
  },
  computed: {
    // @deprecated
    tools() {
      return Object.values(tools[this.entity] || {})
        .filter(tool => isObject(tool) && tool.component);
    },
    actions() {
      // CMS api config actions
      if (toArray(this.config.actions).length > 0) {
        return getEntityActionsByNames(this.config.actions);
      }
      // CMS editor actions
      if (toArray(this.draft.actions).length > 0) {
        return getEntityActionsByNames(this.draft.actions);
      }
      // Legacy tools config
      return this.tools;
    },
    hasActions() {
      return this.actions.length > 0;
    },
  },
  methods: {
    reset() {
      this.loading = false;
      this.currentAction = null;
    },
    setLoading(loading) {
      this.loading = loading;
    },
    setCurrentAction(action) {
      this.currentAction = action;
    },
  },
};
</script>
